module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.2.0-90.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.2.0.md
// module id = 507
// module chunks = 330